import React from 'react';
import Image from 'next/image';
import { css } from 'styled-system/css';

import ShaojiangLink from '@shaojiang/components/ShaojiangLink';
import { Button } from '@shaojiang/components/ui/button';

export default function Error() {
  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: '6',
      })}
    >
      <Image src='/images/error.svg' width={800} height={591} alt='Something went wrong' />
      <p className={css({ my: '10', textAlign: 'center', color: 'fg.muted' })}>
        {`It's not your fault, it's ours. We are working on it.`}
      </p>
      <Button size='lg' asChild>
        <ShaojiangLink href='/'>Go Home</ShaojiangLink>
      </Button>
    </div>
  );
}
